import httpService from './httpService';
import { User } from '../utils/types';

export const createUser = async (user: User) => {
	const { data } = await httpService.post(`/users`, user);
	return data;
};

export const search = async (params?: any) => {
	const { data } = await httpService.get(`/users/search`, { params });
	return data;
};

export const getUser = async (id: string) => {
	const { data } = await httpService.get(`/users/${id}`);
	return data;
};

export const deleteUser = async (id: string | number) => {
	const { data } = await httpService.delete(`/users/${id}`);
	return data;
};

export const updateUser = async (user: any) => httpService.put(`/users/${user.id}`, user);
